<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_7"></a><span class="red1">Introduction</span></h1>
<p class="noindent"><span class="dblue">Christmas means so much to so many people. It is about family, faith, and hope for the future, and it is a celebration of where we are now. No wonder we quilters make so many Christmas quilts.</span></p>
<p class="noindent"><span class="dblue">We make Christmas quilts with love in our hearts, to share that love with family and friends. We hope that you enjoy making—and sharing—many of the projects in this book.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607052029_06_intro.vue?7d3567b0